type ClassValue = string | false | null | undefined | 0

/** Joins truthy class names. No conflict resolution: components never accept a class that fights their own. */
export function cx(...values: ClassValue[]): string {
  let out = ''
  for (const v of values) if (v) out = out ? `${out} ${v}` : v
  return out
}
